const bootstrapUntilBySlot = new Map<string, number>()

export function markFormPageBootstrap(slotId: string, durationMs = 1200): void {
  const id = String(slotId ?? '').trim()
  if (!id) return
  bootstrapUntilBySlot.set(id, Date.now() + durationMs)
}

export function isFormPageBootstrapActive(slotId: string | null | undefined): boolean {
  const id = String(slotId ?? '').trim()
  if (!id) return false
  const until = bootstrapUntilBySlot.get(id)
  if (until == null) return false
  if (Date.now() > until) {
    bootstrapUntilBySlot.delete(id)
    return false
  }
  return true
}
